import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const ReportsIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2276 10.4077L20.5 4.20472L19.2399 2.9585L14.2276 7.9153L9.77235 3.50925L3.5 9.71228L4.76015 10.9585L9.77235 6.00169L14.2276 10.4077ZM20.5005 9.875V20.875H18.5005V9.875H20.5005ZM10.5005 10.875V20.875H8.50049V10.875H10.5005ZM5.50091 14.6643L5.5 21.0393L3.5 21.0391L3.50091 14.6641L5.50091 14.6643ZM15.5144 21.0366L15.498 14.6616L13.498 14.6668L13.5144 21.0418L15.5144 21.0366Z"
        fill={props.fill ?? '#3F1D75'}
      />
    </SvgWrapper>
  );
};
